import { STags } from "shj-components"

export const config = {
  rowSelection: false,
  pagination: false,
  tableType: 'antd',
  columns: [
    {
      title: '工艺工序/类别名称',
      dataIndex: 'processCatName',
      width: 250,
      name: 'processName',
    },
    {
      title: '工艺名称',
      dataIndex: 'processName',
      width: 250,
      name: 'processName',
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: '状态',
      dataIndex: 'processEnabled',
      width: 150,
      name: 'processEnabled',
      render: (text: any) => {
        return (
          <STags
            itemKey=""
            label={text ? '启用' : '禁用'}
            fontColor={text ? '#00A865' : '#EB3723'}
            bgColor={text ? '#D7F7EA' : '#FFEAE8'}
          />
        )
      },
    },
    {
      title: '产品采购价（元）',
      dataIndex: 'price',
      width: 150,
      name: 'price',
    },
    // {
    //   title: '报错信息',
    //   dataIndex: 'errorMessages',
    //   width: 550,
    //   name: 'errorMessages',
    //   render: (error: any) => (<div style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
    //     <Tooltip
    //       overlayStyle={{ maxWidth:600 }}
    //       title={
    //         <>
    //           {error?.map(item => (<div>{ item.errorMessage }</div>))}
    //         </>
    //       }
    //     >
    //       <span style={{ color: 'red' }}>{error?.map(item => item.errorMessage)?.join(',')}</span>
    //     </Tooltip>
    //   </div>),
    // },
  ],
  search: false,
  footer: [],
}
